type DateLike = string | number | Date | null | undefined;

const toConsoleDate = (value: DateLike): Date | null => {
    if (!value) return null;

    // Nova sometimes omits a timezone suffix. Treat those timestamps as UTC so
    // a browser does not reinterpret the provider timestamp as local time.
    const normalized = typeof value === 'string' && !/(?:[zZ]|[+-]\d{2}:?\d{2})$/.test(value)
        ? /^\d{4}-\d{2}-\d{2}$/.test(value)
            ? `${value}T00:00:00Z`
            : `${value}Z`
        : value;
    const date = value instanceof Date ? value : new Date(normalized);

    return Number.isNaN(date.getTime()) ? null : date;
};

/** A scan-friendly, locale-stable date for console tables and resource cards. */
export const formatConsoleDate = (value: DateLike): string => {
    const date = toConsoleDate(value);
    if (!date) return 'Not available';

    return new Intl.DateTimeFormat('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    }).format(date);
};

/** A locale-stable timestamp for operation and audit events. */
export const formatConsoleDateTime = (value: DateLike): string => {
    const date = toConsoleDate(value);
    if (!date) return 'Not available';

    return new Intl.DateTimeFormat('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).format(date);
};
